import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Helmet } from 'react-helmet';
import IMAGES from 'modules/assets/web';
import Toast from 'modules/toast';

import apiFetch from 'modules/api-fetch';

class SetPasswordPage extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  componentDidMount() {
    window.location.href = 'https://nerdfitness.com/lostpassword?coaching=true';
  }

  setPassword = async (values, formikProps) => {
    console.devLog.info('Set values:', values);
    // Default generic password reset triggers
    const config = {
      url: 'MobileAccount/ResetClientPassword',
      method: 'POST',
      query: {
        clientEmail: values.email,
      },
    };

    try {
      const response = await apiFetch(config);

      if (response) {
        Toast.success('Great! Triggered a password reset e-mail to you.');
      } else {
        Toast.error(
          'Encountered an error. E-mail not found or other issue encountered',
        );
      }
    } catch (er) {
      Toast.error(
        'Encountered an error. E-mail not found or other issue encountered.',
      );
      console.devLog.info('Error:', er);
    } finally {
      formikProps.setSubmitting(false);
    }
  };

  render() {
    return (
      <div className="signin-wrapper col-xs-10 col-sm-8 col-md-6 col-lg-4 mx-auto">
        <Helmet>
          <title>Reset Password</title>
        </Helmet>

        <Formik
          initialValues={{
            email: '',
          }}
          onSubmit={this.setPassword}
          render={formikProps => (
            <Form className="form-signin">
              <img
                className="mb-4 d-block mx-auto w-50"
                src={IMAGES.COACHING_1}
                alt=""
              />

              <h1 className="h3 mb-3 font-weight-normal text-center">
                Reset Password
              </h1>
              <div className="form-group">
                <label htmlFor="name">E-mail Address</label>
                <Field
                  type="email"
                  name="email"
                  placeholder="Your E-mail"
                  className="form-control form-control-sm"
                />
                <ErrorMessage name="email" />
              </div>

              <button
                type="submit"
                disabled={formikProps.isSubmitting}
                readOnly={formikProps.isSubmitting}
                className="btn btn-lg btn-primary btn-block"
              >
                Set Password
              </button>
              <div className="mt-2">
                <p className="font-italic">
                  If your password is already set, you can head{' '}
                  <Link to="/signin">directly to the sign in page here.</Link>
                </p>
              </div>
              <div className="mt-2">
                <p className="font-italic">
                  If you encounter any issues resetting your password please
                  reach out to coaching@nerdfitness.com and we'll get you
                  squared away ASAP.
                </p>
              </div>
            </Form>
          )}
        />
      </div>
    );
  }
}

export default withRouter(SetPasswordPage);

// https://getbootstrap.com/docs/4.0/examples/sign-in/
